import { useAuth } from '../contexts/AuthContext';

/**
 * Wrapper component that hides its children for Viewer (read-only) users.
 * Use this around any create/edit/delete/write controls.
 * 
 * Usage: <WriteOnly><button>Delete</button></WriteOnly>
 */
export const WriteOnly = ({ children }) => {
  const { isViewer } = useAuth();
  if (isViewer) return null;
  return children;
};

/**
 * Wrapper that shows its children ONLY to Viewer users.
 * Use for read-only indicators or masked values.
 */
export const ViewerOnly = ({ children }) => {
  const { isViewer } = useAuth();
  if (!isViewer) return null;
  return children;
};

/**
 * Masks sensitive values for Viewer users.
 * Shows "••••••••" instead of the actual value.
 */
export const MaskedValue = ({ value, children }) => {
  const { isViewer } = useAuth();
  if (isViewer) return <span className="text-[#A3B5C7]/40">••••••••</span>;
  return children || <span>{value}</span>;
};

export default WriteOnly;
